<div class="container non-login" [ngClass]="{'modal': isLoginModal, 'page': !isLoginModal}">
  <div class="account-btn-group main-page-width">
    <ion-button expand="block" class="secondary-button" (click)="onSsoLogin('Google')" name="Continue with Google">
      <ion-icon name="logo-google"></ion-icon>{{'Continue with Google' | translate}}
    </ion-button>
    <ion-button expand="block" class="secondary-button" (click)="onSsoLogin('Apple')" name="Continue with Apple">
      <ion-icon name="logo-apple"></ion-icon> {{'Continue with Apple' | translate}}
    </ion-button>
    <ion-text class="or-text">{{'or' | translate}}</ion-text>
    @if(isLoginModal) {
      <ion-button expand="block" class="secondary-button" (click)="onContinueWithEmail()" name="Continue with Email">
        <ion-icon class="at-the-rate" name="at-outline"></ion-icon> {{'Continue with Email' | translate}}
      </ion-button>
      <ion-button expand="block" class="secondary-button" (click)="onContinueWithPhone()" name="Continue with Phone">
        <ion-icon class="at-the-rate" name="phone-portrait-outline"></ion-icon> {{'Continue with Phone' | translate}}
      </ion-button>
    } @else {
      <ion-button expand="block" class="secondary-button" (click)="onContinueWithEmailAndPhone()" name="Continue with Email/Phone">
        <ion-icon class="at-the-rate" name="at-outline"></ion-icon> {{emailBtnText | translate}}
      </ion-button>
    }
  </div>
</div>
